export default __webpack_public_path__ + "static/media/Abinash Patnaik.bdb2510e.JPG";